{
  "title": "Hogares",
  "search": "Buscar",
  "state": "Estado",
  "archiveHousehold": "Hogares archivados",
  "editHousehold": "Editar hogar",
  "houseHold": "Hogar",
  "houseHoldChangesOnly": "Solo cambios en el hogar",
  "completed": "Perfil completado",
  "notCompleted": "Perfil sin completar",
  "incompleteFields": "Campos incompletos",
  "allDocumentSigned": "Todos los documentos firmados",
  "unsignedDocuments_one": "1 documento sin firmar",
  "unsignedDocuments_other": "{{count}} documentos sin firmar",
  "unsignedDocumentsTooltip": "Firme los documentos accediendo a la pestaña de documentos.",
  "idVerified": "ID verificada",
  "idNotVerified": "ID no verificada",
  "idVerificationNotCompletedTooltip": "Agregue una id. de verificación en la pestaña de Detalles de cada miembro",
  "complianceApproved": "Cumplimiento aprobado",
  "complianceNeedsReview": "Es necesario revisar el cumplimiento",
  "complianceNeedsReviewTooltip": "Diríjase a la pestaña Detalles de cada miembro para aprobar los detalles de cumplimiento del cliente",
  "annualInfoUpToDate": "Información anual actualizada",
  "annualInfoNeedsReview": "Actualización de la información anual",
  "annualInfoNeedsReviewTooltip": "La última revisión de idoneidad se realizó hace más de {{months}} meses. Actualice la información del cliente: seleccione el botón Editar en el estado del perfil en la pestaña Detalles del miembro",
  "addModal": {
    "title": "Añadir hogar nuevo",
    "name": "Nombre del hogar",
    "type": "Tipo de hogar",
    "primaryUser": "Contacto principal",
    "relationships": "Relaciones",
    "add": "Añadir",
    "searchUser": "Buscar",
    "createARelation": "Crear relaciones",
    "organization": "Organización",
    "relation": "Relación",
    "relationUser": "Usuario de relación",
    "nameRequired": "El nombre del hogar es obligatorio",
    "primaryUserRequired": "El contacto principal es obligatorio"
  },
  "updateModal": {
    "edit": "Editar",
    "update": "Actualizar",
    "title": "Actualizar hogar"
  },
  "billingModal": {
    "title": "Actualizar facturación del hogar"
  },
  "relationModal": {
    "email": "Correo electrónico",
    "userEmail": "Correo electrónico del usuario",
    "relationship": "Relación",
    "affiliationType": "Tipo de afiliación",
    "firstName": "Nombre",
    "middleName": "Segundo nombre",
    "lastName": "Apellido",
    "relationType": "Relación con el miembro principal",
    "permission": "Permiso para el hogar",
    "sin": "Sin",
    "allocation": "Asignación",
    "dateOfBirth": "Fecha de nacimiento",
    "relationTitle": "Añadir relación",
    "updateRelationTitle": "Actualizar relación",
    "createAUser": "Crear nuevo usuario",
    "verifyUser": "Verificar usuario",
    "errorMessage": "El usuario no existe. Haga clic",
    "here": "aquí",
    "createMessage": "para crear un usuario nuevo.",
    "addRelation": "Agregar relación",
    "updateRelation": "Actualizar",
    "removeAffiliate": "Eliminar afiliado",
    "removeAffiliateConfirmation": "¿Confirma que desea eliminar el afiliado?",
    "organization": "Organización de relaciones",
    "errorPre": "Haga clic ",
    "errorPost": " para crear un afiliado nuevo",
    "createAffiliate": "Crear afiliado",
    "addAffiliate": "Añadir afiliado",
    "createUser": "Crear nuevo usuario",
    "createNewClient": "Crear nuevo cliente",
    "client": "Cliente",
    "updateAffiliateTitle": "Actualizar afiliado"
  },
  "archiveHouseholdConfirmation": {
    "areYouSure": "¿Está seguro?",
    "thereAreMembers": "Hay {{numMembers}} cliente(s) en este hogar. Esto no eliminará la información del cliente, pero ya no estará asociado a este hogar.",
    "yesSure": "Sí, confirmo"
  },
  "types": {
    "household": "HOGAR",
    "business": "EMPRESA"
  },
  "table": {
    "headers": {
      "name": "Nombre del hogar",
      "contact": "Contacto principal",
      "email": "Correo electrónico de contacto principal",
      "relationCount": "Número de relaciones",
      "organization": "Organización",
      "marketValue": "Valor de mercado"
    }
  },
  "summary": {
    "members": "Miembros del hogar",
    "primaryContact": "Contacto principal",
    "phone": "Teléfono",
    "email": "Correo electrónico",
    "feeGrid": "Tabla de tarifas",
    "billingCycle": "Ciclo de facturación",
    "feePaymentAccount": "Cuenta de pago de tarifas",
    "multiple": "Múltiple",
    "inheritedDashWhat": "Heredado - {{what}}"
  },
  "tabs": {
    "overview": "Resumen general",
    "members": "Miembros",
    "documents": "Documentos",
    "statements": "Declaraciones",
    "transfers": "Transferencias",
    "ledger": "Libro mayor",
    "trades": "Transacciones",
    "notes": "Notas",
    "auditLog": "Registro de auditoría"
  },
  "overview": {
    "totalHouseholdAssets": "Activos totales del hogar"
  },
  "membersTable": {
    "name": "Nombre",
    "relationship": "Relación",
    "phoneNumber": "Número de teléfono",
    "email": "Correo electrónico",
    "netWorth": "Patrimonio neto",
    "annualIncome": "Ingresos anuales",
    "status": "Estado",
    "marketValue": "Valor de mercado",
    "permissions": "Permisos",
    "editHouseholdMember": "Editar miembro del hogar",
    "removeFromHousehold": "Eliminar del hogar"
  },
  "remove": {
    "accountsExist": "Cuentas vinculadas al hogar existente",
    "thereAreAccountLinked": "{{clientName}} tiene {{count}} cuenta(s) vinculadas a este hogar. Primero, debe desvincular estas cuentas.",
    "areYouSure": "¿Confirma que desea eliminar a {{clientName}} de {{householdName}}?",
    "thisWillNotDelete": "Esto no eliminará la información del cliente, pero ya no estará asociado a este hogar.",
    "yesRemove": "Sí, eliminar",
    "memberHasBeenRemoved": "Cliente eliminado del hogar"
  },
  "removeFromHousehold": {
    "title": "Eliminar cliente del hogar",
    "householdName": "Nombre del hogar",
    "confirm": "Confirmar",
    "error": "No puede eliminar al propietario principal de un hogar.",
    "success": "Cliente eliminado del hogar"
  },
  "householdStateLabel": "Estado del hogar",
  "householdState": {
    "ACTIVE": "Activo",
    "ARCHIVED": "Archivado"
  },
  "accessTypes": {
    "EDIT": "Acceso total",
    "VIEW": "Acceso total",
    "NO_ACCESS": "Sin acceso"
  }
}
